import type { SVGProps } from 'react';

export const CryptoFileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100"
    height="111"
    viewBox="0 0 100 111"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M50 108C77.3381 108 99.5 85.8381 99.5 58.5C99.5 31.1619 77.3381 9 50 9C22.6619 9 0.5 31.1619 0.5 58.5C0.5 85.8381 22.6619 108 50 108Z"
      fill="#BDF5D5"
    />
    <g filter="url(#filter0_d_12168_11174)">
      <path
        d="M78.3801 9H21.6201C19.7975 9 18.3201 10.9271 18.3201 13.3043V103.696C18.3201 106.073 19.7975 108 21.6201 108H78.3801C80.2026 108 81.6801 106.073 81.6801 103.696V13.3043C81.6801 10.9271 80.2026 9 78.3801 9Z"
        fill="white"
      />
      <path
        d="M47.64 19H30.48C29.3865 19 28.5 19.8865 28.5 20.98C28.5 22.0735 29.3865 22.96 30.48 22.96H47.64C48.7335 22.96 49.62 22.0735 49.62 20.98C49.62 19.8865 48.7335 19 47.64 19Z"
        fill="#9DF0BF"
      />
      <path
        d="M59.5202 27.58H30.4802C29.3867 27.58 28.5002 28.4665 28.5002 29.56C28.5002 30.6535 29.3867 31.54 30.4802 31.54H59.5202C60.6138 31.54 61.5002 30.6535 61.5002 29.56C61.5002 28.4665 60.6138 27.58 59.5202 27.58Z"
        fill="#DEFAEA"
      />
      <path
        d="M47.64 52.54H30.48C29.3865 52.54 28.5 53.4265 28.5 54.52C28.5 55.6135 29.3865 56.5 30.48 56.5H47.64C48.7335 56.5 49.62 55.6135 49.62 54.52C49.62 53.4265 48.7335 52.54 47.64 52.54Z"
        fill="#9DF0BF"
      />
      <path
        d="M59.5202 61.12H30.4802C29.3867 61.12 28.5002 62.0065 28.5002 63.1C28.5002 64.1935 29.3867 65.08 30.4802 65.08H59.5202C60.6138 65.08 61.5002 64.1935 61.5002 63.1C61.5002 62.0065 60.6138 61.12 59.5202 61.12Z"
        fill="#DEFAEA"
      />
      <path
        d="M47.64 86.08H30.48C29.3865 86.08 28.5 86.9665 28.5 88.06C28.5 89.1535 29.3865 90.04 30.48 90.04H47.64C48.7335 90.04 49.62 89.1535 49.62 88.06C49.62 86.9665 48.7335 86.08 47.64 86.08Z"
        fill="#9DF0BF"
      />
      <path
        d="M59.5202 94.66H30.4802C29.3867 94.66 28.5002 95.5465 28.5002 96.64C28.5002 97.7336 29.3867 98.62 30.4802 98.62H59.5202C60.6138 98.62 61.5002 97.7336 61.5002 96.64C61.5002 95.5465 60.6138 94.66 59.5202 94.66Z"
        fill="#DEFAEA"
      />
    </g>
    <path
      d="M72.7535 93.8601C80.7828 91.7086 85.5115 83.5182 83.3601 75.4889C81.2086 67.4596 73.0182 62.7309 64.9889 64.8823C56.9596 67.0337 52.2308 75.2242 54.3823 83.2535C56.5337 91.2828 64.7242 96.0115 72.7535 93.8601Z"
      fill="#49C786"
    />
    <path
      d="M73.4704 80.5975C72.9042 78.4846 71.4423 78.0999 68.8259 78.4775C66.9501 78.7212 66.4585 78.3354 66.232 77.4901C66.0055 76.6448 66.4637 75.9398 67.671 75.6163C68.7577 75.3252 69.4585 75.5256 70.003 76.3503C70.1119 76.5152 70.3253 76.5874 70.5065 76.5389L71.4723 76.2801C71.7138 76.2153 71.8464 75.9857 71.7817 75.7443L71.7655 75.6839C71.1681 74.4204 69.8065 73.6853 68.3857 73.9367L67.9974 72.4878C67.9327 72.2463 67.7031 72.1137 67.3851 72.1341L66.4795 72.3768C66.238 72.4415 66.1054 72.6711 66.1259 72.9893L66.4979 74.3777C64.7515 75.1046 63.9281 76.6192 64.3325 78.1285C64.8663 80.1208 66.284 80.582 68.9004 80.2045C70.6717 80.0534 71.3121 80.27 71.5709 81.236C71.8298 82.202 71.1624 83.0925 70.0155 83.3998C68.4458 83.8204 67.7245 83.3018 67.3007 82.4448C67.1757 82.2196 66.9623 82.1473 66.7811 82.1958L65.7548 82.4708C65.5134 82.5355 65.3808 82.7651 65.4455 83.0067L65.4617 83.0671C66.1075 84.5116 67.3646 85.3394 69.4377 85.1075L69.826 86.5564C69.8906 86.7978 70.1203 86.9304 70.4383 86.9099L71.3438 86.6673C71.5854 86.6026 71.7179 86.3729 71.6975 86.0549L71.3093 84.6061C73.0395 83.8188 73.9071 82.2275 73.4704 80.5975Z"
      fill="#DEFAEA"
    />
    <path
      d="M68.1055 88.829C62.9437 88.4005 59.1215 83.7953 59.6267 78.6776C59.8529 75.8994 61.3275 73.4338 63.56 71.865C63.7692 71.6796 63.8413 71.4661 63.7604 71.1642L63.534 70.3191C63.4693 70.0775 63.3 69.9288 63.0424 69.9332C62.9819 69.9494 62.8612 69.9817 62.817 70.0582C57.5671 73.406 56.0616 80.3447 59.4095 85.5946C61.402 88.6841 64.6936 90.5845 68.3654 90.7653C68.6393 90.8213 68.8485 90.6358 68.844 90.3782C68.8883 90.3017 68.8721 90.2413 68.8398 90.1206L68.6133 89.2753C68.5648 89.0942 68.319 88.9013 68.1055 88.829ZM69.4578 68.2788C69.1839 68.2228 68.9747 68.4082 68.9792 68.6659C68.935 68.7425 68.9511 68.8028 68.9835 68.9236L69.2099 69.7688C69.2747 70.0103 69.5205 70.2031 69.7339 70.2755C74.8957 70.704 78.7179 75.3091 78.2127 80.4269C77.9865 83.2051 76.5119 85.6707 74.2794 87.2395C74.0702 87.4249 73.9981 87.6383 74.079 87.9403L74.3054 88.7854C74.3702 89.027 74.5394 89.1757 74.7971 89.1713C74.8575 89.1551 74.9782 89.1228 75.0224 89.0463C80.2723 85.6985 81.7778 78.7598 78.4299 73.5099C76.4212 70.36 73.0693 68.4758 69.4578 68.2788Z"
      fill="#DEFAEA"
    />
    <path
      d="M75.7535 56.8601C83.7554 54.7159 88.5042 46.4909 86.3601 38.4889C84.2159 30.4869 75.9909 25.7382 67.9889 27.8823C59.9869 30.0264 55.2382 38.2515 57.3823 46.2535C59.5264 54.2555 67.7515 59.0042 75.7535 56.8601Z"
      fill="#49C786"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.1685 43.2117C74.0626 43.2486 73.5135 43.4311 72.2689 43.7646C71.279 44.0299 70.5683 44.1888 70.3186 44.2432C66.4483 45.1015 63.4159 45.2065 63.2041 44.4162C62.9923 43.6258 65.6712 42.2014 69.4514 41.0069L70.1424 43.5858C70.3974 43.5366 71.1249 43.3866 72.1149 43.1213C73.3028 42.803 73.8845 42.5946 73.989 42.5561L73.2982 39.9781C77.1609 39.1238 80.1869 39.0204 80.3982 39.809C80.6095 40.5976 77.9381 42.0209 74.1646 43.2117L74.1685 43.2117ZM73.2303 39.7104L72.612 37.4026L77.9396 35.9751L76.9966 32.456L62.4915 36.3426L63.4344 39.8618L68.7611 38.4345L69.3793 40.7413C65.1025 42.0985 62.0743 43.8211 62.3473 44.8398C62.6203 45.8585 66.1038 45.8353 70.4864 44.8733L72.4679 52.2683L76.3178 51.2368L74.3356 43.839C78.6025 42.4844 81.6255 40.7642 81.3527 39.7464C81.08 38.7285 77.6046 38.7496 73.2292 39.7097L73.2303 39.7104Z"
      fill="#DEFAEA"
    />
    <path
      d="M52.8717 64.08C50.0667 75.3301 38.6708 82.1767 27.4181 79.3713C16.1701 76.5666 9.32274 65.1713 12.129 53.9221C14.9328 42.6708 26.3286 35.8237 37.5778 38.6284C48.8297 41.4331 55.6767 52.8296 52.8714 64.0802L52.8716 64.08H52.8717Z"
      fill="#49C786"
    />
    <path
      d="M41.7785 55.5586C42.2154 52.4938 39.9916 50.8464 36.9507 49.7474L37.9372 45.596L35.5287 44.9663L34.5684 49.0084C33.9352 48.8427 33.2849 48.6866 32.6386 48.5318L33.6059 44.463L31.1989 43.8333L30.2119 47.9834C29.6879 47.8582 29.1732 47.7345 28.6739 47.6042L28.6767 47.5911L25.3553 46.7209L24.7146 49.42C24.7146 49.42 26.5015 49.8498 26.4639 49.8762C27.4392 50.1316 27.6156 50.8091 27.5863 51.346L26.4626 56.0755C26.5297 56.0934 26.6169 56.1193 26.713 56.1598C26.6326 56.1389 26.5471 56.116 26.4584 56.0937L24.8834 62.7191C24.7642 63.03 24.4616 63.4965 23.7797 63.3194C23.8039 63.3561 22.0292 62.861 22.0292 62.861L20.8334 65.7537L23.9677 66.5736C24.5508 66.727 25.1222 66.8875 25.6849 67.0385L24.6882 71.2375L27.094 71.8672L28.081 67.7127C28.7382 67.8999 29.376 68.0726 30.0004 68.2354L29.0167 72.3703L31.4254 73L32.4219 68.8088C36.529 69.6243 39.6172 69.2955 40.917 65.3978C41.9644 62.2597 40.8649 60.4496 38.7042 59.2692C40.2779 58.8884 41.4633 57.8024 41.7794 55.5589L41.7786 55.5584L41.7785 55.5586ZM36.2756 63.655C35.5312 66.7932 30.4955 65.0968 28.8629 64.6714L30.1855 59.1084C31.818 59.536 37.0535 60.3823 36.2757 63.655H36.2756ZM37.0204 55.5131C36.3414 58.3676 32.1502 56.9174 30.7905 56.5618L31.9897 51.5164C33.3493 51.872 37.7278 52.5357 37.0207 55.5131H37.0204Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_12168_11174"
        x="12.3201"
        y="0"
        width="75.36"
        height="111"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12168_11174"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12168_11174"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
